import { useEffect, useState } from "react";

import Grid from "@mui/material/Grid";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import LawCard from "../components/LawCard";
import colors from "assets/theme/base/colors";

// Toast notifications
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'layouts/pages/landing/formular-sesizare/customToast.css';

import useAPI from "utils/useApi";



function LegislationSection() {
  const { info } = colors;
  const client = useAPI();

  const [lawContent, setLawContent] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const response = await client.getLawContent();
        if(response.results.length > 2) {
          setLawContent(response.results.slice(0, 2));
        } else {
          setLawContent(response.results);
        }
      } catch (e) {
        console.error("Error fetching law content:", e);
        toast.error("A apărut o eroare la încărcarea conținutului. Vă rugăm să reîncărcați pagina.");
      }
    })();
  }, []);




  return (
    <>
      <ToastContainer 
        position="top-right" 
        autoClose={4000} 
        hideProgressBar={false} 
        newestOnTop 
        closeOnClick 
        rtl={false} 
        pauseOnFocusLoss 
        draggable 
        pauseOnHover
        theme="light"
      />
      <SoftBox>
      {/* <SoftBox mb={4.5}>
        <SoftTypography variant="h4" color="dark" fontWeight="bold" mb={1.5}>
          Legislație relevantă
        </SoftTypography>
        <SoftBox width="70px" height="4px" bgcolor={info.main} borderRadius="sm" mb={3.5} />
      </SoftBox> */}

      <Grid container spacing={3.5} mb={5}>
        {lawContent.length > 0 && lawContent.map((item) => (
          <Grid item xs={12} md={6} key={item.id}>
          <LawCard 
            icon="description" // "security"
            title={item.title}
            description={item.short_description}
            link={`/legislatie/${item.id}`}
          />
        </Grid>
        ))}
        {lawContent.length === 0 && (
          <Grid item xs={12} md={12}>
            <SoftTypography variant="h4" color="dark" fontWeight="bold" mb={1.5}>
              Legislație în curs de actualizare
            </SoftTypography>
          </Grid>
        )}
      </Grid>
    </SoftBox>
    </>
  );
}

export default LegislationSection;
